<div class="ai-support-chat">
    <button class="chat-toggle" type="button" (click)="toggleChat()" *ngIf="!isOpen" aria-label="Open support chat">
        <mat-icon>chat_bubble</mat-icon>
        <span>Need help?</span>
    </button>

    <section class="chat-panel" *ngIf="isOpen">
        <header>
            <div class="title">
                <h3>Support</h3>
                <p>AI assistant with human backup</p>
            </div>
            <div class="actions">
                <app-button
                    (onClick)="close()"
                    aria-label="Minimize chat"
                    [variant]="'default'"
                    [buttonClass]="'circle-btn'"
                >
                    <mat-icon>close</mat-icon>
                </app-button>
            </div>
        </header>

        <div class="messages" #messageContainer>
            <div
                class="message"
                *ngFor="let message of messages"
                [ngClass]="{
                    user: message.sender === 'user',
                    assistant: message.sender === 'assistant',
                    system: message.sender === 'system'
                }"
            >
                <div class="bubble">
                    <p>{{ message.content }}</p>
                    <span class="timestamp" *ngIf="message.timestamp">{{ message.timestamp | date: "shortTime" }}</span>
                </div>
            </div>

            <div class="status" *ngIf="isSending">
                <mat-progress-spinner diameter="18" mode="indeterminate"></mat-progress-spinner>
                <span>Thinking...</span>
            </div>
        </div>

        <div class="handoff" *ngIf="!isHumanChatActive && isHumanRequestInFlight">
            <mat-icon>support_agent</mat-icon>
            <div>
                <p>Connecting you with the next available specialist…</p>
            </div>
        </div>

        <form class="input-row" (ngSubmit)="sendMessage()">
            <input
                type="text"
                placeholder="Ask a question..."
                [formControl]="messageControl"
                (keydown)="handleEnter($event)"
                aria-label="Message"
            />
            <app-button
                [disabled]="messageControl.invalid || isSending"
                [variant]="'default'"
                [buttonClass]="'circle-btn'"
            >
                <mat-icon>send</mat-icon>
            </app-button>
        </form>
    </section>
</div>
